<template>
  <div v-cloak class="block-list">
    <div class="block-list__item w-full" qaid="order-summary.subtotal">
      <span v-html="bp('orderSubtotal')" />
      <span v-html="orderData.prices.subtotal.formattedValue" />
    </div>
    <div class="block-list__item w-full" qaid="order-summary.estimatedShipping">
      <span v-html="bp('estimatedShipping')" />
      <span v-html="orderData.prices.deliveryCost.formattedValue" />
    </div>
    <div class="block-list__item w-full" qaid="order-summary.estimatedShipping">
      <span v-html="bp('shippingDeductions')" />
      <span v-html="orderData.prices.freightDeduction.formattedValue" />
    </div>
    <div class="block-list__item flex justify-between text-lg py-2" qaid="order-summary.cartTotal">
      <span class="font-medium" v-html="bp('orderTotal')" />
      <span class="font-medium" v-html="orderData.prices.totalPrice.formattedValue" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderData: {
      type: Object,
      required: true,
      default: () => {},
    },
    baseProperties: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
};
</script>
